import { ILikeInfo } from '../api/types';
import { ILikes } from '../model/types';

export function mapLiks(dto: ILikeInfo): ILikes {
  return {
    first_name: `${dto.user.first_name} ${dto.user.last_name}`,
    name_settlement: dto.settlement.name,
  };
}
